var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.167,
    height: 21.083,
    viewBox: "0 0 19.167 21.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48698",
    "data-name": "Group 48698",
    transform: "translate(-43 -496.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42368",
    "data-name": "Group 42368",
    transform: "translate(43 495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_9_",
    "data-name": "svgexport-6 (9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23000",
    "data-name": "Path 23000",
    d: "M135.667,345.165a3.833,3.833,0,1,1-3.833-3.833A3.833,3.833,0,0,1,135.667,345.165Zm0,0",
    transform: "translate(-122.25 -325.999)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23001",
    "data-name": "Path 23001",
    d: "M16.3,52.176A6.693,6.693,0,0,1,11.11,42.85a6.686,6.686,0,0,0-8.235,6.526v2.672A6.426,6.426,0,0,1,.586,56.967a1.677,1.677,0,0,0,1.091,2.951H17.49a1.677,1.677,0,0,0,1.081-2.959A6.417,6.417,0,0,1,16.3,52.176Zm0,0",
    transform: "translate(0 -40.751)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27671",
    "data-name": "Path 27671",
    d: "M2.867,52.176a6.713,6.713,0,0,0,5.757-6.633,6.665,6.665,0,0,0-.568-2.693,6.685,6.685,0,0,1,8.235,6.526v2.672a6.426,6.426,0,0,0,2.288,4.919,1.677,1.677,0,0,1-1.091,2.951H1.677A1.677,1.677,0,0,1,.6,56.959,6.417,6.417,0,0,0,2.867,52.176Zm0,0",
    transform: "translate(0 -40.751)",
    fill: "#ffc107"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.c7730eeef4100b0600d8674e6a97b379.svg";
export { ForwardRef as ReactComponent };